// src/Components/Form/index.tsx
import { yupResolver } from '@hookform/resolvers/yup';
import { method } from 'lodash';
import * as React from 'react';
import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  useForm,
  UseFormReturn,
  ValidationMode,
} from 'react-hook-form';
import { AnyObjectSchema } from 'yup';

export interface IFormProps<T extends FieldValues, TValidationSchema> {
  onSubmit: SubmitHandler<T>;
  onError?: (errors: any) => void; // 1) ADD THIS onError PROP
  children: (methods: UseFormReturn<T>) => React.ReactNode;
  defaultValues?: any;
  validationSchema?: TValidationSchema;
  className?: string;
  validationMode?: keyof ValidationMode;
  isValid?: boolean;
  id?: string;
}

export default function Form<
  T extends FieldValues,
  TValidationSchema extends AnyObjectSchema = AnyObjectSchema,
>(props: IFormProps<T, TValidationSchema>) {
  const {
    onSubmit,
    onError, // 2) DESTRUCTURE onError
    children,
    defaultValues,
    validationSchema,
    validationMode,
    className = 'h-full md-max:h-auto',
    isValid,
    ...rest
  } = props;

  const methods = useForm<T>({
    resolver: validationSchema ? yupResolver(validationSchema) : undefined,
    defaultValues,
    mode: validationMode,
  });

  React.useEffect(() => {
    if (isValid !== undefined) {
      methods.trigger();
    }
  }, [isValid]);

  return (
    <FormProvider {...methods}>
      <form
        className={className}
        // 3) PASS onError AS THE SECOND ARGUMENT TO handleSubmit
        onSubmit={methods.handleSubmit(onSubmit, onError)}
        {...rest}
      >
        {children(methods)}
      </form>
    </FormProvider>
  );
}
